import React, { Component } from 'react'
import styled from 'styled-components'
import IntegrationItem from './integrationItem'

// import mercosVar from './../../../assets/images/mercos_var.png'
// import eco3 from './../../../assets/images/eco3.png'
// import picpay from './../../../assets/images/picpay.png'
// import rkr from './../../../assets/images/rkr.png'
// import gerenciagram from './../../../assets/images/gerenciagram.png'
// import mercadolivre from './../../../assets/images/mercadolivre.png'
// import tagplusuniversidade from './../../../assets/images/tagplusuniversidade.png'
import Arrow from './../../../svgs/arrow-right.svg'
// import contabilivre from './../../../assets/images/contabilivre.png'
import donuz from './../../../assets/images/donuz.png'
import soluti from './../../../assets/images/soluti.png'
import mercos from './../../../assets/images/mercos.png'
import nexoos from './../../../assets/images/nexoos.png'
import flip from './../../../assets/images/flip.png'
import uplogos from './../../../assets/images/uplogos.png'
import nuvemshop from './../../../assets/images/nuvemshop.png'
import rapidoo from './../../../assets/images/rapidoo.png'
import rd from './../../../assets/images/rd.png'
import sms from './../../../assets/images/sms.png'
import lojaintegrada from './../../../assets/images/lojaintegrada.png'
import spc from './../../../assets/images/spc.png'
import woocommerce from './../../../assets/images/woocommerce.png'
// import tray from './../../../assets/images/tray.png'
// import olist from './../../../assets/images/olist.png'
// import stone from './../../../assets/images/stone.png'
import mlabs from './../../../assets/images/mlabs.png'
import webstore from './../../../assets/images/webstore.png'
// import assertiva from './../../../assets/images/assertiva.png'
import moovin from './../../../assets/images/moovin.png'
import pluggto from './../../../assets/images/pluggto.png'
import arlocal from './../../../assets/images/arlocal.png'
import querycommerce from './../../../assets/images/querycommerce.png'
import kiskadi from './../../../assets/images/kiskadi.png'
import wbuy from './../../../assets/images/wbuy.png'
import fiscali from './../../../assets/images/fiscali.png'
import base from './../../../assets/images/base.png'
import moodmade from './../../../assets/images/moodmade.png'
import we_sign from './../../../assets/images/we_sign.png'
import d4_sign from './../../../assets/images/d4_sign.png'
import fidelimax from './../../../assets/images/fidelimax.png'
import shopee from './../../../assets/images/shopee.png'
import globalcerti from './../../../assets/images/globalcerti.png'
import lunet from './../../../assets/images/lunet.png'
import ann from './../../../assets/images/ANN.png'


const Container = styled.section`
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: 1fr;
  grid-template-areas: "options" "itens";
  padding-top: 0;
  @media(min-width: 769px){
    grid-template-columns: 367px 1fr;
    grid-template-areas: "options itens";
    padding: 30px;
  }
`
const Options = styled.div`
display: block;
grid-area: options;
/* position: sticky; */
top: 0;
`
const Products = styled.div`
grid-area: itens;
display: flex;
flex-wrap: wrap;
position: relative;
align-items: baseline;
@media(max-width: 769px){
  box-sizing: content-box;
  justify-content: center;
}
`

const List = styled.ul`
  padding: 39px;
  border-radius: 20px;
  list-style: none;
  margin: 0;
  @media(min-width: 769px){
    background-color: #316FFF;
  }
  
`
const LinkListItem = styled.a `
  text-decoration: none;
  display: block;
  & + &{
    margin-top: 20px;
  }
  &[filter="0"]{
    @media (max-width: 768px){
      & + & {
        display: none;
      }

    }
  }
  `

const ListItem = styled.li`
  border-radius: 25px;
  padding: 12px 18px;
  text-align: center;
  margin: 0 auto;
  box-sizing: border-box;
  font-size: 0.8em;
  font-family: "Be Vietnam", sans-serif;
  font-weight: bold;
  cursor: pointer;
  position: relative;
  
  width: 100%;
  color: #316FFF;
  border: 1px solid #316FFF;
  @media(min-width: 769px){
    color: #FFF;
    border: 1px solid #FFF;
    &:nth-child(2){
      margin-top: 0;
    }
    &[target="show"]{
      display: none;
    }
  }
  &:hover,
  &.active {
    border-color:  #FDC910;
    color: #FDC910;
    svg g{
      @media (max-width: 768px){
        fill: #FDC910;
      }
    }
  }
`
const ArrowContainer = styled(Arrow)`
  position: absolute;
  left: calc(100% - 30px);
  top: 17px;
  transition: all 0.3s cubic-bezier(0.4, 0.01, 0.165, 0.99);
  @media (min-width: 769px){
    display: none;
    cursor: pointer;
  }
`

class Integrations extends Component{
  
  constructor(props){
    super(props);
    this.produtos =  {
      mercos: {
        logo: mercos,
        title: 'Mercos',
        description: 'Tenha sua loja virtual sincronizada com o TagPlus.',
        stars: 5,
        url: 'https://mercos.com/parceiros/tagplus/'
      },
      lojaintegrada: {
        logo: lojaintegrada,
        title: 'Loja Integrada',
        description: 'Crie sua loja virtual e tenha um layout profissional.',
        stars: 5,
        url: 'https://indiquei.app/LZAJGAQ'
      },
      nuvemshop: {
        logo: nuvemshop,
        title: 'NuvemShop',
        description: 'Tenha sua loja virtual sincronizada com o TagPlus.',
        stars: 5,
        url: 'https://www.nuvemshop.com.br/partners/tagplus'
      },
      woocommerce: {
        logo: woocommerce,
        title: 'Woocommerce',
        description: 'Tenha sua loja virtual sincronizada com o TagPlus.',
        stars: 5,
        url: 'https://ajuda.tagplus.com.br/pt-BR?q=woocommerce'
      },
      // picpay: {
      //   logo: picpay,
      //   title: 'PicPay',
      //   description: 'Pagar & receber ficou mais fácil do que enviar uma mensagem.',
      //   stars: 5,
      //   url: 'https://ajuda.tagplus.com.br/pt-BR/articles/3453674-utilizando-o-picpay-no-sistema-online'
      // },
      sms: {
        logo: sms,
        title: 'TagPlus SMS',
        description: 'Envie mensagens SMS com informativos personalizados',
        stars: 5,
        url: 'https://ajuda.tagplus.com.br/pt-BR/articles/2892612-como-funciona-o-tagplus-sms'
      },
      rapidoo: {
        logo: rapidoo,
        title: 'Rapidoo',
        description: 'Antecipe o recebimento das suas vendas de forma rápida.',
        stars: 5,
        url: 'https://rapidoo.com.br/tagplus?utm_medium=cpa&utm_source=tagplus&utm_campaign=integracao_appstore'
      },
      spc: {
        logo: spc,
        title: 'SPC',
        description: 'Efetue de forma rápida consultas de pendências Financeiras.',
        stars: 5,
        url: 'https://ajuda.tagplus.com.br/pt-BR?q=spc+serasa'
      },
      rd: {
        logo: rd,
        title: 'RD Station CRM',
        description: 'Funil de Vendas muito eficaz para sua empresa.',
        stars: 5,
        url: 'https://ajuda.tagplus.com.br/pt-BR/articles/2008448-como-integrar-o-rd-station-crm-ao-tagplus'
      },
      // gerenciagram: {
      //   logo: gerenciagram,
      //   title: 'Gerenciagram',
      //   description: 'Comece a automatizar o seu instagram profissional.',
      //   stars: 5,
      //   url: 'https://gerenciagram.com.br/?ref=G9478012A'
      // },
      
     
      // mercadolivre: {
      //   logo: mercadolivre,
      //   title: 'Mercado Livre',
      //   description: 'Sincronize todos os seus produtos cadastrados no Tagplus.',
      //   stars: 5,
      //   url: 'https://ajuda.tagplus.com.br/pt-BR?q=Mercado+Livre'
      // },
      // rkr: {
      //   logo: rkr,
      //   title: 'RKR Store',
      //   description: 'Crie sua loja virtual e tenha um layout profissional.',
      //   stars: 5,
      //   url: 'https://www.rkrstore.com.br/'
      // },
      
      soluti: {
        logo: soluti,
        title: 'Soluti',
        description: 'Faça agora mesmo seu certificado digital sem burocracia.',
        stars: 5,
        url: 'https://infoco.tagplus.com.br/'
      },
    
      donuz: {
        logo: donuz,
        title: 'Donuz',
        description: 'Chegou a hora de fidelizar e reter seus clientes.',
        stars: 5,
        url: 'https://www.donuz.com.br/tagplus'
      },
      // contabilivre: {
      //   logo: contabilivre,
      //   title: 'Contabilivre',
      //   description: 'Abra sua empresa agora mesmo, é rápido e fácil!',
      //   stars: 5,
      //   url: 'https://contabilivre.tagplus.com.br/'
      // },
      nexoos: {
        logo: nexoos,
        title: 'Nexoos',
        description: 'Investidores que oferecem crédito',
        stars: 5,
        url: 'https://ajuda.tagplus.com.br/pt-BR/articles/3460052-como-funciona-a-integracao-com-a-nexoos'
      },
      flip: {
        logo: flip,
        title: 'Flip Digital',
        description: 'Crédito na medida para a sua empresa, e com a melhor taxa.',
        stars: 5,
        url: 'https://sso.flipdigital.com.br/account/register?origem=tagplus'
      },
      uplogos: {
        logo: uplogos,
        title: 'Up Logos',
        description: 'Tenha sua marca pronta de forma profissional em 48 horas.',
        stars: 5,
        url: 'https://uplogos.com.br/tagplus/'
      },
      // tagplusuniversidade: {
      //   logo: tagplusuniversidade,
      //   title: 'TagPlus Universidade',
      //   description: 'Venha se capacitar e aprimorar seus conhecimentos.',
      //   stars: 5,
      //   url: 'https://universidade.tagplus.com.br/'
      // },
      // eco3: {
      //   logo: eco3,
      //   title: 'Eco3 Energia',
      //   description: 'Economia de energia com instalação de sistemas fotovoltáicos.',
      //   stars: 5,
      //   url: 'https://eco3energia.com.br/'
      // },
      // tray: {
      //   logo: tray,
      //   title: 'Tray',
      //   description: 'Plataforma de ecommerce para vender de verdade.',
      //   stars: 5,
      //   url: 'https://www.tray.com.br/'
      // },
      // olist: {
      //   logo: olist,
      //   title: 'Olist',
      //   description: 'Ajudando quem quer vender a encontrar quem quer comprar.',
      //   stars: 5,
      //   url: 'https://download.olist.com/partners-parceiro-tagplus'
      // },
      /*stone: {
        logo: stone,
        title: 'Stone',
        description: 'Stone é a maquininha de cartão ideal para você',
        stars: 5,
        url: 'https://stone.tagplus.com.br/'
      },*/
      // mercosVar: {
      //   logo: mercosVar,
      //   title: 'Mercos Varejo',
      //   description: 'Crie sua loja online e faça delivery de seus produtos agora mesmo.',
      //   stars: 5,
      //   url: 'https://materiais.mercos.com/tagplus'
      // },
      mlabs: {
        logo: mlabs,
        title: 'MLabs',
        description: 'Comece a gerenciar suas redes sociais.',
        stars: 5,
        url: 'https://mlabs.tagplus.com.br'
      },
      webstore: {
        logo: webstore,
        title: 'Webstore',
        description: 'Venda seus produtos em vários canais',
        stars: 5,
        url: 'https://ajuda.tagplus.com.br/pt-BR/articles/5195240-como-integrar-o-tagplus-a-webstore'
      },
      // assertiva: {
      //   logo: assertiva,
      //   title: 'Assertiva',
      //   description: 'Reduza a inadimplência na sua empresa',
      //   stars: 5,
      //   url: 'https://ajuda.tagplus.com.br/pt-BR/articles/5208690-como-funciona-a-consulta-spc-assertiva'
      // },
      moovin: {
        logo: moovin,
        title: 'Moovin',
        description: 'Plataforma Ecommerce completa projetada para aumentar as suas vendas.',
        stars: 5,
        url: 'https://www.moovin.com.br/#utm_source=Tag%20Plus&utm_medium=Link%20de%20parceiro&utm_campaign=Link%20de%20parceiro%20Tag%20Plus'
      },
      pluggto: {
        logo: pluggto,
        title: 'Plugg.to',
        description: 'Plugg.to integração com Marketplaces mais Completo e Confiável',
        stars: 5,
        url: 'https://conteudo.plugg.to/parceria-tagplus'
      },
      arlocal: {
        logo: arlocal,
        title: 'Ar Local',
        description: 'Empresa especializada na geração de certificados digitais ICP-Brasil.',
        stars: 5,
        url: 'https://arlocal.com.br/?utm_source=tagplus_site_aplicativos'
      },
      querycommerce: {
        logo: querycommerce,
        title: 'Query Commerce',
        description: 'Planeje sua operação de vendas online com a plataforma magento.',
        stars: 5,
        url: 'https://integrador.querycommerce.com/'
      },
      kiskadi: {
        logo: kiskadi,
        title: 'Kiskadi',
        description: 'A Kiskadi é um CRM que oferece programa de cashback e campanhas de Whatsapp/SMS',
        stars: 5,
        url: 'https://kiskadi.com/tagplus-partner/'
      },
      wbuy: {
        logo: wbuy,
        title: 'WBuy',
        description: 'Tudo o que sua loja virtual precisa num só lugar.',
        stars: 5,
        url: 'https://www.wbuy.com.br/?r=FAE3GIO9'
      },
      fiscali: {
        logo: fiscali,
        title: 'Fiscali',
        description: 'A Fiscali é especializada em recuperação de crédito tributário.',
        stars: 5,
        url: 'https://fiscali.com.br/contato/'
      },
      base: {
        logo: base,
        title: 'Base',
        description: 'A ferramenta para gerenciar seu e-commerce e marketplaces em um só lugar!',
        stars: 5,
        url: 'https://base.com/pt-BR/home/'
      },
      moodmade: {
        logo: moodmade,
        title: 'MoodMade',
        description: 'Especializados em simplificar processos e unir pessoas, trazendo cada vez mais qualidade para a gestão de negócios da sua empresa',
        stars: 5,
        url: 'https://moodmade.com.br/'
      },
      we_sign: {
        logo: we_sign,
        title: 'We Sign',
        description: 'A We Sign é uma empresa brasileira de tecnologia especializada em soluções para assinatura eletrônica de documentos.',
        stars: 5,
        url: 'https://www.wesign.com.br/parceiros'
      },
      d4_sign: {
        logo: d4_sign,
        title: 'D4 Sign',
        description: 'A D4Sign é a maior plataforma de assinatura eletrônica e digital do Brasil, criada para empresas que buscam mais eficiência, segurança e inovação nos seus processos.',
        stars: 5,
        url: 'https://landing.d4sign.com.br/tagplus?assunto=tagplus'
      },
      fidelimax: {
        logo: fidelimax,
        title: 'Fidelimax',
        description: 'A Fidelimax é uma plataforma completa para fidelizar clientes, aumentar suas vendas e gerar mais engajamento de forma inteligente.',
        stars: 5,
        url: 'https://www.fidelimax.com.br/gratis/'
      },
      shopee: {
        logo: shopee,
        title: 'Shopee',
        description: 'A Shopee é uma das maiores plataformas de e-commerce da atualidade, oferecendo uma ampla variedade de produtos e ferramentas inovadoras para vendedores.',
        stars: 5,
        url: 'https://www.shopee.com.br/'
      },
      globalcerti: {
        logo: globalcerti,
        title: 'GlobalCerti',
        description: 'A GLOBALCERTI CERTIFICADOS DIGITAIS é uma empresa que oferece soluções inovadoras, proporcionando agilidade, praticidade e segurança a seus clientes e parceiros.',
        stars: 5,
        url: 'https://keepo.io/GlobalCertidigital'
      },
      lunet: {
        logo: lunet,
        title: 'Lúnet',
        description: 'Organize, integre e simplifique o dia a dia das suas equipes de vendas - com mais autonomia e menos complicação.',
        stars: 5,
        url: 'https://lunet.trinitysuite.com.br/agendar/bf77b83e762dc99fcd45343b03f211493c55435a'
      },
      ann: {
        logo: ann,
        title: 'ANN',
        description: 'Especialista em Implantação e treinamento do Sistema para Loja Física e E-commerce.',
        stars: 5,
        url: 'https://wa.me/5521968155332?text=Estou%20no%20site%20da%20ANN%20Consultoria%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%3A%20Sistema%20TagPlus'
      }
    }
    this.defaultProdutos = [
      this.produtos.mercos,
      this.produtos.lojaintegrada,
      // this.produtos.picpay,
      // this.produtos.tagplusuniversidade,
      // this.produtos.tray,
      // this.produtos.olist,
      // this.produtos.mercosVar,
      this.produtos.nuvemshop,
      this.produtos.rapidoo,
      // this.produtos.contabilivre,
      this.produtos.donuz,
      // this.produtos.gerenciagram,
      this.produtos.soluti,
      // this.produtos.mercadolivre,
      this.produtos.nexoos,
      this.produtos.rd,
      // this.produtos.rkr,
      this.produtos.spc,
      this.produtos.flip,
      this.produtos.uplogos,
      // this.produtos.eco3,
      this.produtos.woocommerce,
      //this.produtos.stone,
      this.produtos.sms,
      this.produtos.mlabs,
      this.produtos.webstore,
      // this.produtos.assertiva,
      this.produtos.moovin,
      this.produtos.pluggto,
      this.produtos.arlocal,
      this.produtos.querycommerce,
      this.produtos.kiskadi,
      this.produtos.wbuy,
      this.produtos.fiscali,
      this.produtos.base,
      this.produtos.moodmade,
      this.produtos.we_sign,
      this.produtos.d4_sign,
      this.produtos.fidelimax,
      this.produtos.shopee,
      this.produtos.globalcerti,
      this.produtos.lunet,
      this.produtos.ann
    ];

    this.state = { 
      itens: this.defaultProdutos,
      show: false,
      width: 0
      };

      this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      this.elements = [
        {
          title: 'Filtrar Aplicativos',
          target: 'show',
          active: false,
          arrow: true,
          itens: []
        },
        {
          title: 'Todos os Aplicativos',
          target: 'all',
          active: true,
          arrow: false,
          itens: this.defaultProdutos
        },
        {
         title: 'Automação Vendas e Marketing',
         target: 'mkt',
         active: false,
         arrow: false,
         itens: [
          this.produtos.rd,
          // this.produtos.gerenciagram,
          // this.produtos.picpay,
          this.produtos.uplogos,
          // this.produtos.tagplusuniversidade,
          //this.produtos.stone,
          this.produtos.mlabs,
          this.produtos.kiskadi
          
         ]
       },
       {
         title: 'E-commerce',
         target: 'ecommerce',
         active: false,
         arrow: false,
         itens: [
          // this.produtos.mercosVar,
          this.produtos.mercos,
          this.produtos.moovin,
          this.produtos.lojaintegrada,
          this.produtos.nuvemshop,
          this.produtos.woocommerce,
          // this.produtos.mercadolivre,
          // this.produtos.rkr,
          // this.produtos.tray,
          // this.produtos.olist,
          this.produtos.webstore,
          this.produtos.pluggto,
          this.produtos.querycommerce,
          this.produtos.wbuy,
          this.produtos.base,
          this.produtos.ann
         ]
       },
       {
        title: 'Marketplaces',
        target: 'marketplace',
        active: false,
        arrow: false,
        itens: [
         // this.produtos.olist,
         this.produtos.pluggto,
        //  this.produtos.tray,
         this.produtos.webstore,
         this.produtos.wbuy,
         this.produtos.base,
         this.produtos.moovin,
         this.produtos.shopee
        ]
      },
       {
         title: 'Certificados e Assinaturas Digitais',
         target: 'certificados-assinaturas-digitais',
         active: false,
         arrow: false,
         itens: [
          this.produtos.soluti,
          this.produtos.arlocal,
          this.produtos.we_sign,
          this.produtos.d4_sign,
          this.produtos.globalcerti
         ]
       },
       {
         title: 'Gestão de Clientes e Vendas',
         target: 'clientes-vendas',
         active: false,
         arrow: false,
         itens: [
          this.produtos.mercos,
          this.produtos.rapidoo,
          this.produtos.donuz,
          this.produtos.rd,
          this.produtos.fidelimax,
          this.produtos.lunet
          //this.produtos.stone
         ]
       },
      //  {
      //    title: 'Contábil',
      //    target: 'contabil',
      //    active: false,
      //    arrow: false,
      //    itens: [
      //     // this.produtos.contabilivre
      //    ]
      //  },
       {
         title: 'Finanças',
         target: 'financas',
         active: false,
         arrow: false,
         itens: [
          this.produtos.nexoos,
          // this.produtos.picpay,
          this.produtos.rapidoo,
          this.produtos.flip,
          this.produtos.fiscali
          // this.produtos.assertiva
         ]
       }
  
       ]

       
    this.handleitens = this.handleitens.bind(this);
    
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    if(document.location.hash !== ''){
      this.handleitens(document.location.hash.replace('#', ''));
    }
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {

    this.setState({ width: window.screen.width });
  }
  handleitens(key){
    this.updateWindowDimensions();
    if(key !== 'show'){
      const newElements = {...this.elements};
      let selected = [];
      for(let element in newElements) {
        if(newElements[element].target === key && !newElements[element].active){
          selected = newElements[element].itens
        }
        if(key !== 'show'){
          newElements[element].active = newElements[element].target === key
        }
        
      }
      if(selected.length){
        this.setState({
          itens: selected,
          elements: newElements
        })
      }
      if(this.state.width <= 768){
        this.setState({
          show: false
        })
      }
      
    }else{
      
      this.setState({
        show: !this.state.show
      })
    }
  }
  render() {
    return (
      <Container>
        <Options>
        {this.elements.map((item , key) => (
          <input type="hidden" id={item.target} key={key} />
        ))}
          <List data-aos="zoom-out-up" data-aos-duration="600">
          {this.elements.map((item , key) => (
            <LinkListItem href={'#'+item.target} filter={this.state.show ? 1 : 0} >
              <ListItem onClick={evt => this.handleitens(item.target)} className={item.active ? 'active' : ''} key={key} target={item.target}>{item.title} 
              {item.arrow && (<ArrowContainer className={this.state.show ? 'rotate' : 'backrotate'} />) }
            </ListItem>
            </LinkListItem>
            
          ))}
          </List>
        </Options>
        <Products>
          {this.state.itens.map((item, key) => (<IntegrationItem key={key} {...item} />))}
        </Products>
  </Container>
    )
  }
}
 
export default Integrations
